<template>
    <v-dialog
        v-model="display"
        width="100%"
        max-width="800px"
        :content-class="$vuetify.breakpoint.smAndUp ? 'guestEditDialogDesktop' : 'guestEditDialogMobile'"
        persistent
        scrollable>
        <v-card>
            <v-card-text class="pb-0">
                <v-container v-if="eventEvoucher" fluid class="px-0 pb-0 mt-3">
                    <v-label>{{$t('evoucher.edit')}}</v-label>
                    <v-form ref="form" v-model="isFormValid">
                        <v-container fluid class="px-0 pb-0">
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        label="Day"
                                        placeholder=" "
                                        v-model="eventEvoucher.day"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                        label="Location"
                                        placeholder=" "
                                        v-model="eventEvoucher.location"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pt-0">
                                    <v-switch
                                        label="Disabled"
                                        v-model="eventEvoucher.is_disabled"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="secondary" @click="closeDialog">
                    {{$t('cancel')}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveEventEvoucher">
                    {{$t('save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind, useGet} from "feathers-vuex";

    export default {
        name: 'EventEvoucherGuestsEdit',
        props: {
            displayGuestEditDialog: Boolean
        },
        setup(props, {root}) {
            const {EvoucherGuest} = root.$FeathersVuex.api;
            
            const display = ref(true);
            
            const form = ref(null);
            const isFormValid = ref(false);

            const eventId = computed(() => root.$route.params.eventId);
            const evoucherGuestsId = computed(() => root.$route.params.evoucherGuestsId);
            const {item: eventEvoucher} = useGet({model: EvoucherGuest, id: evoucherGuestsId});
            
            const closeDialog = () => {
                root.$router.replace({name: 'evoucher-guests'});
            }

            const saveEventEvoucher = async () => {
                if (isFormValid.value) {
                    try {
                        await eventEvoucher.value.save();
                        root.$store.dispatch('showSnackBar', 'Evoucher Saved.');
                        closeDialog();
                    } catch (e) {
                        root.$handleFeatherError(e);
                    }
                } else {
                    form.value.validate();
                }
            };
            
            return {
                form,
                isFormValid,
                saveEventEvoucher,
                
                eventEvoucher,
                closeDialog,
                display,
            }
        },
    }
</script>